import React from "react";
import styled from "styled-components";
import { Colors } from "../../config/Constants";

interface CustomTabsProps {
  tabs: {
    label: string;
    value: number;
  }[];
  activeTab: number;
  handleTab: React.Dispatch<React.SetStateAction<number>>;
}
interface TabProps {
  value: number;
  activeTab: number;
}

const CustomTabs = ({ tabs, activeTab, handleTab }: CustomTabsProps) => {
  return (
    <TabManager>
      {tabs.map(({ label, value }, index) => (
        <Tab
          key={index}
          value={value}
          activeTab={activeTab}
          onClick={() => {
            handleTab(value);
          }}
        >
          {label}
        </Tab>
      ))}
    </TabManager>
  );
};

export default CustomTabs;

const TabManager = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: ${Colors.alto};
  border-radius: 0.5rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;
const Tab = styled.div<TabProps>`
  border-radius: 0.375rem;
  width: 100%;
  margin: 0.25rem;
  min-width: 6.25rem;
  padding: 0.5rem 1.5rem;
  text-align: center;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.5s ease;
  color: ${(props) =>
    props.value === props.activeTab ? Colors.appleRed : Colors.aluminium};
  user-select: none;
  background-color: ${(props) =>
    props.value === props.activeTab ? Colors.white : "none"};
  :hover {
    background-color: ${Colors.white}66;
  }
  @media only screen and (max-width: 768px) {
    width: auto;
  }
`;
